import {GeoCodeFragment} from '../../../../gql/graphql';
import {mapNullToUndefined} from '../../../utils/mapperHelper.utils';
import {AddressLocation} from '@wix/auto_sdk_ecom_cart-v-2';

export class GeoCodeModel {
  public latitude?: number;
  public longitude?: number;

  constructor(params: GeoCodeModel) {
    this.latitude = params.latitude;
    this.longitude = params.longitude;
  }

  public static fromCheckoutV1(geocode?: GeoCodeFragment | null) {
    return new GeoCodeModel({
      latitude: mapNullToUndefined(geocode?.latitude),
      longitude: mapNullToUndefined(geocode?.longitude),
    });
  }
  /* istanbul ignore next */
  public static fromCartV2(geocode?: AddressLocation) {
    if (!geocode) {
      return undefined;
    }
    return new GeoCodeModel({
      latitude: mapNullToUndefined(geocode?.latitude),
      longitude: mapNullToUndefined(geocode?.longitude),
    });
  }
}
